// @flow
import React from 'react'
// $FlowFixMe
import ReactPhoneInput from 'react-phone-input-2'
// $FlowFixMe
import 'react-phone-input-2/lib/style.css'
import { FormField, StyledField, Label, Error, SecondLabel } from 'src/components/Form'
import type { Field as FieldProps } from 'src/types'

const renderPhone = ({
  input,
  label,
  autocomplete,
  placeholder,
  secondLabel,
  altError,
  meta: { touched, error }
}: FieldProps) => (
  <div className="infoContainer">
    <FormField>
      <Label>{label}</Label>
      <SecondLabel> {secondLabel}</SecondLabel>
      <StyledField hasError={touched && error} column>
        <ReactPhoneInput
          {...input}
          inputExtraProps={{
            name: 'phoneNumber'
          }}
          autoFormat
          defaultCountry={'intl'}
          countryCodeEditable
          preferredCountries={['gb', 'us']}
          country={'gb'}
          inputStyle={{
            width: '82%',
            marginLeft: '15px',
            border: 'none',
            fontSize: '100%',
            height: '50px',
            paddingLeft: '60px',
            backgroundColor: 'transparent'
          }}
          regions={['america', 'europe', 'asia', 'oceania', 'africa']}
          buttonStyle={{
            border: 'none',
            backgroundColor: 'transparent',
            padding: '0 10px 0 10px'
          }}
          dropdownStyle={{
            width: '350px'
          }}
          autoComplete={autocomplete}
          placeholder={placeholder}
        />
        {touched && error && (
          <Error>
            Oh, you need to type your {`${altError || label}`.toLowerCase()} here to continue
          </Error>
        )}
      </StyledField>
    </FormField>
  </div>
)

export default renderPhone



// WEBPACK FOOTER //
// ./src/helpers/fieldRenderers/Phone.js